module.exports = __webpack_public_path__ + "static/img/icon_swipe_04.27790a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_swipe_04.png
// module id = GSuK
// module chunks = 1